<template>
  <v-dialog v-model="dialog" max-width="800">
    <v-card>
      <v-card-title class="border-bottom"> {{stockData?.code + ' - ' + stockData?.name}}
        <v-spacer></v-spacer>

        <v-btn
            color="danger darken-1" style="color: white;"
            @click="dialog = false"
        >KAPAT</v-btn></v-card-title>
      <v-card-text>
        <ProductBalanceTable :single-stock="productObject"></ProductBalanceTable>
      </v-card-text>
      <v-card-actions>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import ProductBalanceTable from "@/pages/views/product/ProductBalanceTable.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "StockDetailDialog",
  components: { ProductBalanceTable },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    stockData: {
      type: Object,
      default: () => ({})
    },
    product: {}
  },
  data() {
    return {
      dialog: false,
      productObject: {}
    }
  },
  methods: {
    ...mapActions("stock",["fetchSingleStock"])
  },
  computed: {
    ...mapState('stock', ['singleStock', "singleStockHeaders", "singleStockLoading"]),
  },
  watch: {
    // "stockCode": function (newVal) {
    //   this.fetchSingleStock({
    //     params: {
    //       stockCode: newVal,
    //     },
    //     body: {}
    //   });
    // },
    "dialog": function (newVal) {
      this.$emit("dialogChange",newVal)
    },
    "showDialog": function (newVal) {
      this.dialog = newVal;
    },
    stockData: function (newVal) {
      this.productObject = Object.assign({}, newVal);
    }
  }
}
</script>

<style scoped>

</style>